import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentComponent } from './payment.component';
import { FormsModule }   from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, SharedModule],
    declarations: [PaymentComponent],
    exports: [PaymentComponent]
})

export class PaymentModule { }
